export default __webpack_public_path__ + "media/images/theme/m_logo_light-f48ea777082a79810bba2d04b21f745f.png";